import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const CouponBottomSheetHTML: FC = () => {
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const currentUser = useSelector(
    (state: RootState) => state.client.userCompany
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const titleURL = getFontURL(fontFamily?.title);
  const couponTitleURL = getFontURL(fontFamily?.coupon_title);
  const couponSubTitleURL = getFontURL(fontFamily?.coupon_sub_title);
  const couponDateURL = getFontURL(fontFamily?.coupon_date);
  const btnURL = getFontURL(btnFontFamily?.button);
  const couponBtnURL = getFontURL(btnFontFamily?.coupon_button);

  // const titleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.title}`;
  // const couponTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.coupon_title}`;
  // const couponSubTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.coupon_sub_title}`;
  // const couponDateURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.coupon_date}`;
  // const btnURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily.button}`;
  // const couponBtnURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily.coupon_button}`;
  const closeImageUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABaUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4eHh8fHy0tLS4uLqamprW1teLi4uPj4/Ly8oZg+lAAAAAUdFJOUwAQIDBAUF9gb3CPkJ+gr7C/z9/vMBy4TQAAAvhJREFUaN7FmtuaqyAMhYO1ZVMdR2H1LO//mvvCdkZbhITSb9Ztdf2VQAgHIpZUbfbdYB0AONt3e1MrKiWlW4uAhlZXBdxNj4j6Nxl11H1St83/8xYsWZ3l/8+BrQxEbSGSEFF1EKsVhHvnkCH2R6g9MrVnDb7KIluW0UwbhzdkN8nmx5vaJTo/3pb5sH+UsEMRrbbSBoW0Kd8/l3LB3qqK+QM2NOL2KKj9q79GUe0+F4CVMLQorO6jDQQA9QIQaKDjdfSXY9po7Tmb+IDj6L334znlf56eO8ZTRuADLt5zCJO/99dAnFU0At5zCA9/P0azXqiLjhzCj7/3iERhG3r36tOEmf8l1pGCNcphTBJm/rdDsHK9D+Lk62HC3P8U9lDRQZYgMPzvYe6RQ+D4T21UsTrJM4HlP7WRRgaB6Q+dyqMrBK4/WiIaICaw/WGJFCAl8P0BRTWkBIk/ajIQEkT+MNRARpD5oyHOYmlOkPnjmxgr4QVB5o+BeOXKK4HnD0vMBc0zgekPR9wqZEng+gNswILA988EpKsZOWDZRHxCbpC5BJfdTZkEm8jWkYHGI/TSVHEbZYRvYbK7nc4yQiNL17cTo156Ste10F9IqCVT5mP8SgiKEv00OL/wCQMRfYn9BYSWX3gt8xuXoClat0TmXyah4ha/r/mZRZgWCCbHn0eYNjpVlj+LcN9PCLbRMV2fzAnHcCK671OHfrww5scZ4Rr6fRtbxrLm31/CGFvGBsM8sub3X8JqiImIlFtdJ6fqhwfhEt8NMWvr5HR9MhFC62Sd2M45XPztekhPKWvP2eWBR/kNqafThK60f/u8KejK+r+eJOiPNhARccoLvpq/2FouGIa1o5xPb+8XC3TkPM2U8I8e4pgP+xdopeR54+at3uo2f3/USKSyx3TDvamgsz7CCc6sqy+5fye7nyD9CFuLT/UlCGey7iVwEdZkX0PZMmbSvqZ3VOn41RNT4A5Npb+C2wG21QVv6NSm6frH9Z+ha9jXf/4D6/hXXVtJWDsAAAAASUVORK5CYII=';
  const style = `
  @font-face {
    font-family: 'title';
    src: url(${titleURL});
    }

  @font-face {
    font-family: 'couponTitle';
    src: url(${couponTitleURL});
    }
  @font-face {
    font-family: 'couponSubTitle';
    src: url(${couponSubTitleURL});
    }
  @font-face {
    font-family: 'couponDate';
    src: url(${couponDateURL});
    }
  @font-face {
    font-family: 'btn';
    src: url(${btnURL});
    }
  @font-face {
    font-family: 'couponBtn';
    src: url(${couponBtnURL});
    }

    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;
      
      position: relative;
      background: none;
      overflow: hidden;
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0,${displayValue});
    }
    .modal_wrapper {
      width: 100%;
      // height: 20.5rem;
      padding: 1rem 10% 2rem 10%;

      position: absolute;
      bottom: 0;

      overflow: hidden;
      border-radius: ${radius?.background}px ${radius?.background}px 0 0;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .close_btn {
      width: 100%;
      display: flex;
      justify-content: end;
    }
    .close_btn button {
      width: 1.5rem;
      height: 1.5rem;
      
      background-image: url(${closeImageUrl});
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }

    .contents_box {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
    }
    .contents_box .title {
      width: 100%;
      min-height: 3rem;

      display: flex;
      align-items: center;
    }
    .title .title_inner {
      width: 100%;
      height: auto;
      max-height: 2.8rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.title};
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily?.title
          : 'title'
      };
    }

    .contents_box .middle {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
    }
    .middle .middle_left {
      width: 2rem;
      height: 2rem;
      position: absolute;
      top: 5rem;
      left: -1rem;

      border-radius: 2rem;
      border: 2px solid #323232;
      ${
        bg === 'image'
          ? 'background-image: transparent'
          : `background: ${bgColor?.background};`
      };
    }
    .middle .middle_right {
      width: 2rem;
      height: 2rem;
      position: absolute;
      top: 5rem;
      right: -1rem;

      border-radius: 2rem;
      border: 2px solid #323232;
      ${
        bg === 'image'
          ? 'background-image: transparent'
          : `background: ${bgColor?.background};`
      };
    }
    .middle .middle_top {
      height: 6rem;
      padding: 1rem;

      border-top: 2px solid #323232;
      border-right: 2px solid #323232;
      border-left: 2px solid #323232;
      border-bottom: 2px dashed #323232;
    }
    .middle_top .middle_title {
      height: 1.5rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: ${textAlign?.coupon_title};
      color: ${color?.coupon_title};
      font-size: ${fontSize?.coupon_title}rem;
      font-weight: ${fontWeight?.coupon_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.coupon_title
        )
          ? fontFamily?.coupon_title
          : 'couponTitle'
      };
    }
    .middle_top .sub_title,
    .middle_top .date {
      height: 1.25rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: ${textAlign?.coupon_sub_title};
      color: ${color?.coupon_sub_title};
      font-size: ${fontSize?.coupon_sub_title}rem;
      font-weight: ${fontWeight?.coupon_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.coupon_sub_title
        )
          ? fontFamily?.coupon_sub_title
          : 'couponSubTitle'
      };
    }
    .middle_top .date {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      text-align: ${textAlign?.coupon_date};
      color: ${color?.coupon_date};
      font-size: ${fontSize?.coupon_date}rem;
      font-weight: ${fontWeight?.coupon_date};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.coupon_date
        )
          ? fontFamily?.coupon_date
          : 'couponDate'
      };
    }

    .middle .middle_bottom {
      height: 3rem;

      display: flex;
      justify-content: center;
      align-items: center;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.coupon_button};
      font-size: ${btnFontSize?.coupon_button}rem;
      font-weight: ${btnFontWeight?.coupon_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.coupon_button
        )
          ? btnFontFamily?.coupon_button
          : 'couponBtn'
      };

      border-right: 2px solid #323232;
      border-left: 2px solid #323232;
      border-bottom: 2px solid #323232;
    }

    .btn_wrapper {
      width: 100%;
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      color: ${btnColor?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily?.button
          : 'btn'
      };

      border: 0;
      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
    }

		@media screen and (min-width: 608px) and (max-width: 1024px) {
      .modal_wrapper {
        padding: 1rem 25% 2rem 25%;
      }
      .contents_box {
        gap: 1rem;
      }

      .contents_box .title,
      .contents_box .middle,
      .contents_box .btn_wrapper {
        width: 20rem;
      }

      .contents_box .title {
        height: 4rem;
      }
      .title .title_inner {
        max-height: 3.6rem;
        font-size: ${fontSize?.title + 0.5}rem;
      }

      .middle_top .middle_title {
        font-size: ${fontSize?.coupon_title + 0.375}rem;
      }
    }
  `;

  const html = `
    <div class="root" id="test">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="modal_wrapper">
        <div class="close_btn">
          <button class="close_btn_inner">close</button>
        </div>
        <div class="contents_box">
          <div class="title">
            <div class="title_inner">${changeEnterHTML(text?.title)}</div>
          </div>
          <div class="middle">
            <div class="middle_left"></div>
            <div class="middle_right"></div>
            <div class="middle_top">
              <p class="middle_title">${changeEnterHTML(text?.coupon_title)}</p>
              <p class="sub_title">${changeEnterHTML(
                text?.coupon_sub_title
              )}</p>
              <p class="date">${changeEnterHTML(text?.coupon_date)}</p>
            </div>
            <div class="middle_bottom">
              <p class="button">${btnText?.coupon_button}</p>
            </div>
          </div>
          <div class="btn_wrapper">
            <button class="btn_inner">
              ${btnText?.button}
            </button>
          </div>
        </div>
      </div>
    </div>
  `;

  let tracking_list = '[';
  for (let i = 0; i < tracking?.button?.length; i++) {
    tracking_list += `['${tracking?.button?.[i]}', '${tracking?.sub_button?.[i]}', '${tracking?.coupon_button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'COUPON BOTTOM SHEET',
    button1,
    button2
  );

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    let tracking = ${tracking_list};
    let button1 = ${tracking_button_list[0]};
    let button2 = ${tracking_button_list[1]};
    $('.btn_inner').click(function() {
      appboyBridge.logClick(tracking[0][0]);
      try {
        if (button1[0].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[0].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = '${deeplink?.background}';
    });
    $('.close_btn_inner').click(function() {
      appboyBridge.logClick(tracking[0][1]);
      try {
        if (button1[1].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[1].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
    $('.button').click(function() {
      appboyBridge.logClick(tracking[0][2]);
      try {
        if (button1[2].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[2].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = '${deeplink?.background}';
    });
  });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};

export default CouponBottomSheetHTML;
